import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { images } from '../constants'

const SectionWrapper = styled.section`
  width: 100%;
  padding: 120px 0 140px;
  @media screen and (max-width: 1023px) {
    padding: 120px 0 130px;
  }
  @media screen and (max-width: 800px) {
    padding: 10px 0 120px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  .quote-btn {
    margin: 30px 0 0 0;
    border: 2px solid var(--secondary);
    background-color: var(--secondary);
    &:hover {
      border: 2px solid var(--grey-hover);
      background-color: var(--grey-hover);
    }
  }
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
    .quote-btn {
      margin: 20px 0 0 0;
    }
  }
`
const ShopifyIcon = styled.div`
  display: flex;
  width: 100%;
  height: 0px;
  position: relative;
  z-index: 0;
  img {
    position: absolute;
    opacity: 0.035;
    left: calc(50% - 130px);
    top: -100px;
    width: 260px;
  }
  @media screen and (max-width: 1023px) {
    img {
      top: -80px;
    }
  }
  @media screen and (max-width: 900px) {
    img {
      top: -60px;
    }
  }
  @media screen and (max-width: 800px) {
    img {
      top: -150px;
    }
  }
  @media screen and (max-width: 560px) {
    img {
      top: -100px;
    }
  }
`
const LeftColumn = styled.div`
  width: 100%;
  padding-right: 30px;
  @media screen and (max-width: 800px) {
    padding-right: 0;
    text-align: center;
    h2 {
      width: 80%;
      margin-left: 10%;
    }
  }
  @media screen and (max-width: 560px) {
    h2 {
      width: 90%;
      margin-left: 5%;
    }
  }
`
const RightColumn = styled.div`
  width: 100%;
  padding-left: 30px;
  @media screen and (max-width: 800px) {
    padding: 30px 0 0;
    text-align: center;
  }
`

const HomeAction = () => {
  const handleLinkClick = () => {
    console.log('home action')
    window.dataLayer.push({ event: 'btn_get_free_quote' })
  }

  return (
    <SectionWrapper>
      <SectionContainer>
        <LeftColumn>
          <h2>Are you ready to make your Shopify project a reality?</h2>
        </LeftColumn>
        <RightColumn>
          <ShopifyIcon>
            <img src={images.service_card_shopify} alt="Shopify" />
          </ShopifyIcon>
          <p>As a Shopify expert I can help you get started on the right track. I offer a free quote so you can get an idea of what it will take to bring your vision to life. With my expertise, I can create a unique and functional Shopify store that meets the highest standards for design and functionality. Contact me today and let's get started on creating something amazing!</p>
        </RightColumn>
      </SectionContainer>
      <SectionContainer>
        <LeftColumn></LeftColumn>
        <RightColumn>
          <Link onClick={handleLinkClick} to="/get-a-free-quote" className="button quote-btn">
            Get a free quote
          </Link>
        </RightColumn>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default HomeAction
